import GlobalMixin from '@/app/shared/mixins/global';

export default {
    mixins: [
        GlobalMixin,
    ],
    props: {
        panelId: {
			type: String,
			require: true,
		},
		translatePrefix: {
			type: String,
			default: 'global',
		},
		url: {
			type: String,
			require: true,
		},
    },
    data(){
        return {

        }
    },
    computed: {

    },
}